var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFontSize(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8 14.55H10.3L6.66942 4H5.07942L1.5 14.55H3L4 11.55H7.9L8.8 14.55ZM5.81219 6H5.9378L7.34 10.05H4.42L5.81219 6Z",
    fill: "#9A99AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 14.55H15.1693V13.4924C14.6218 14.2718 13.8411 14.6 12.8047 14.6C11.4026 14.6 10.2106 13.7425 10.2106 12.2275C10.2106 10.7432 11.3026 9.7607 13.0277 9.64534L15.1693 9.49923L15.1694 8.87447C15.1694 7.85164 14.1976 7.47307 13.5299 7.47307C12.973 7.47307 12.6836 7.5811 12.3588 7.8682C12.1511 8.05186 12.0575 8.28045 12.0128 8.55001H10.5186L10.5413 8.32076C10.7181 6.99031 12.0255 6.1136 13.5891 6.1136C14.9999 6.1136 16.5 7.15181 16.5 8.87447V14.55ZM13.0508 13.4924C12.1347 13.4924 11.5 13.0602 11.5 12.1545C11.5 11.2489 12.1332 11.0539 13.1892 10.9693L15.1693 10.8232V11.2489C15.1693 12.4332 14.3068 13.4924 13.0508 13.4924Z",
    fill: "#9A99AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFontSize);
export default __webpack_public_path__ + "static/media/fontSize.659c10ff9ca2a712f39201cb8884df6e.svg";
export { ForwardRef as ReactComponent };